var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRpmMonitor2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 20.003,
    viewBox: "0 0 13 20.003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_2",
    "data-name": 2,
    transform: "translate(0 0.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3860",
    "data-name": "Path 3860",
    d: "M13,20H10.35a1.3,1.3,0,0,1-1.3-1.3V6.16L7.63,8.64a1.307,1.307,0,0,1-2.26,0L3.95,6.16V18.55a1.3,1.3,0,0,1-1.3,1.3H0V17.26H1.35V1.3A1.3,1.3,0,0,1,3.78.66L6.5,5.39,9.22.65a1.3,1.3,0,0,1,2.43.64V17.4H13Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRpmMonitor2);
export default __webpack_public_path__ + "static/media/rpm_monitor_2.8d512dde5e3d2342eca9b45016d5b2b5.svg";
export { ForwardRef as ReactComponent };